import { useQuery } from "@tanstack/react-query";
import { ApiGetBinanceSpotEthBtcQuote } from "@/api";
import type { GetBinanceSpotEthBtcQuoteResponse } from "@/api/types";

/**
 * 顶栏 BTC/ETH 行情：Redis 中币安 24h ticker（game 每 30s 拉取），前端 5s 轮询。
 */
export function useBinanceSpotEthBtcQuote() {
  return useQuery({
    queryKey: ["binanceSpotEthBtcQuote"],
    queryFn: async (): Promise<GetBinanceSpotEthBtcQuoteResponse> => {
      const res = await ApiGetBinanceSpotEthBtcQuote();
      return res.data;
    },
    refetchInterval: 5000,
    retry: 2,
  });
}
